<template>
  <div class="navbar">
    <nav class="navbar-container row-justify-center">
      <div class="nav-item row-center">
        <slot name="left">
          <div class="spacer row-center" @click="goBack">
            <svg class="icon-back">
              <use xlink:href="#icon-back" />
            </svg>
          </div>
        </slot>
      </div>
      <div class="nav-item row-center">
        <slot>
          <span class="nav-title">{{ title }}</span>
        </slot>
      </div>
      <div class="nav-item row-center">
        <slot name="right">
          <div class="spacer row-center"></div>
        </slot>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'navbar',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    goBack() {
      this.$emit('back-btn-click');
      // 当从短链接等外部打开而不存在后退页面时，跳转到首页
      if (window.history && window.history.length === 1) {
        return this.$router.replace('/');
      }
      this.$router.back();
    },
  },
};
</script>

<style lang="stylus" scoped>
.navbar-container {
  height: 11.73vw;
  background-color: #fff;
}

.nav-item {
  height: 100%;

  .spacer {
    min-width: 15vw;
    height: 100%;
  }

  .icon-back {
    icon-size(6.5vw);
  }

  .nav-title {
    font-size: 4vw;
    font-weight: bold;
  }
}
</style>
